import enUS from "./app/locales/en-US.json";
import esUS from "./app/locales/es-US.json";
import { normalizeKey } from "./app/util/normalizeKey";
import { resolveI18nMessage } from "./app/util/resolveMessage";
import { i18nDefaults } from "./i18n.defaults";
let cachedNormalizedLicensedTerritory;
const getNormalizedLicensedTerritory = () => {
	if (cachedNormalizedLicensedTerritory) return cachedNormalizedLicensedTerritory;
	const licensedTerritory = useRuntimeConfig().public.licensedTerritory;
	if (!licensedTerritory) return undefined;
	cachedNormalizedLicensedTerritory = normalizeKey(licensedTerritory);
	return cachedNormalizedLicensedTerritory;
};
export default () => ({
	domainLocale: ["en"],
	fallbackLocale: "en",
	fallbackWarn: false,
	globalInjection: true,
	legacy: false,
	messageResolver: (translations, key) => resolveI18nMessage(translations, key, getNormalizedLicensedTerritory()),
	messages: {
		en: {
			...i18nDefaults,
			...enUS
		},
		es: {
			...i18nDefaults,
			...esUS
		}
	},
	missing: (locale, key) => {
		if (import.meta.server) return;
		const nuxtApp = tryUseNuxtApp();
		if (!nuxtApp) return;
		if (key.includes("i18n.internal.playnow")) return;
		nuxtApp.runWithContext(() => {
			const { log } = useDatadog();
			log("warn", {
				message: `Missing translation for ${key}`,
				messageContext: {
					key,
					locale
				}
			});
		});
	},
	missingWarn: false
});
